import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BaseRelatedCustomerLocationsState } from '../reducers/base-related-customer-locations.reducer';

const getRelatedCustomerLocationsState =
  createFeatureSelector<BaseRelatedCustomerLocationsState>('relatedCustomerLocations');

export const getRelatedCustomerLocationsList = createSelector(getRelatedCustomerLocationsState, (state) => state.list);

export const getRelatedCustomerLocationDetails = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.details
);

export const getRelatedCustomerLocationDocuments = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.customerLocationDocuments
);

export const getRelatedCustomerLocationDownloadDocument = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.downloadDocument
);

export const getRelatedCustomerLocationDepartments = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.departments
);

export const getRelatedCustomerLocationPriceList = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.priceList
);

export const getRelatedCustomerLocationSurcharges = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.surcharges
);

export const getDepartmentUserList = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.departmentUserList
);

export const getQualificationWithPrice = createSelector(
  getRelatedCustomerLocationsState,
  (state) => state.qualificationWithPrice
);
